module.exports = __webpack_public_path__ + "static/dinosaurs-comet.9edde64d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/schools/dinosaurs-comet.jpg
// module id = 502
// module chunks = 139666322020541